// a library to wrap and simplify api calls
import JSZip from "jszip";
import Api from "./PhiApi";
import CONSTANTS from "./Constants";
import Phi from "./Phi";

export default class PhiOrganization {
  constructor(options) {
    this.phiRef = options;

    this.getProgramByOrganization = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token.jwt)) {
        let response = yield Api.getProgramByOrganization(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          let results = response.data.results[0];
          let programs = results.org_count
            ? JSON.parse(results.org_count).org.organization
            : null;
          let startNodeMap = {};

          if (programs) {
            programs.map((program) => {
              let startNode = CONSTANTS.getNode(program.events, "Start Node");
              startNodeMap[program.billing.id] = startNode;
              return program;
            });
          }

          return { ok: true, error: false, programs, startNodeMap };
        } else {
          return { ok: false, error: response.problem };
        }
      }
    };

    this.getProgram = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token.jwt)) {
        const { id } = config;
        let response = yield Api.getProgram(id);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          const details = JSON.parse(response.data.results[0].billingjson);

          if (details.org.organization && details.org.organization.length) {
            let program = details.org.organization[0].billing;
            program = program ? [program] : null;
            let events = details.org.organization[0].events;
            delete details.org.organization[0].billing;
            delete details.org.organization[0].events;
            let orgDetails = details.org.organization[0];
            let history = details.org.organization[0].history;
            history = history && history.length ? history : null;

            return { program, events, orgDetails, history };
          } else {
            return null;
          }
        } else {
          return { error: response.problem };
        }
      }
    };

    this.fetchStudentList = function* (that, payload) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.fetchStudentList(payload);

        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      } else {
        return { error: "authentication error" };
      }
    };

    this.fetchCustomStudentList = function* (that, payload) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.fetchCustomStudentList(payload);

        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      } else {
        return { error: "authentication error" };
      }
    };

    this.convertBase64toBlob = (content, contentType) => {
      contentType = contentType || "";
      let sliceSize = 512;
      let byteCharacters = window.atob(content); //method which converts base64 to binary
      let byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, {
        type: contentType,
      }); //statement which creates the blob

      return blob;
    };

    this.getReport = function* (that, reportType, config) {
      let token = that.phiRef.getSession(that.phiRef);

      if (token) {
        let htmlContent,
          styleContent,
          pdfContent,
          reportHeaderstyle = "";
        let response = yield Api.getReport(reportType, config);

        if (response.ok && response.data && response.data.output) {
          let base64 = response.data.output;

          if (config.type === "html") {
            let zipFile = new JSZip();
            let content = yield zipFile.loadAsync(base64, { base64: true });
            if (content && content.files) {
              let files = content.files;
              for (let key in files) {
                let obj = files[key];
                let fileData = yield obj.async("string");
                if (key.endsWith(".css")) {
                  styleContent = fileData;
                } else if (key.endsWith(".zip") || key.endsWith(".htm")) {
                  htmlContent = fileData;
                }
              }

              for (let file in files) {
                let imageBase64 = null;
                let obj = files[file];

                if (file.endsWith(".png")) {
                  imageBase64 = yield obj.async("base64");
                  htmlContent = htmlContent
                    .split(file)
                    .join(`data:image/png;base64, ${imageBase64}`);
                }
              }

              styleContent +=
                ".frame-content >  table { width: 100%; height: 100%; }";
              //retaining the styles coming in the reports
              if (htmlContent.indexOf('<style type="text/css">')) {
                reportHeaderstyle = htmlContent.substring(
                  htmlContent.indexOf('<style type="text/css">'),
                  htmlContent.indexOf("</head>")
                );
                reportHeaderstyle = reportHeaderstyle.replace(
                  '<style type="text/css">',
                  ""
                );
                reportHeaderstyle = reportHeaderstyle.replace("</style>", "");
                styleContent += reportHeaderstyle;
              }

              htmlContent = htmlContent
                .substr(htmlContent.indexOf("<body>"), htmlContent.length)
                .replace(/\n+/g, "")
                .replace(/>\s+</g, "><");
              htmlContent = htmlContent
                .replace("</body></html>", "")
                .replace(`<body>`, `<style>${styleContent}</style>`);

              return { data: htmlContent };
            }
          } else if (config.type === "pdf") {
            pdfContent = that.convertBase64toBlob(base64, "pdf");

            return { data: pdfContent };
          }
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.editOrganization = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.editOrganization(config.organizationId, {
          orgJson: JSON.stringify([config.organizationData]),
          changeDesc: "Edit organization",
          userid: Phi.User.profile().user_id,
        });
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.getClasses = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getClasses(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          let groupedClasses = {};
          response.data.results.forEach(
            (i) =>
              (groupedClasses[i.class] = !!groupedClasses[i.class]
                ? [...groupedClasses[i.class], i.section]
                : [i.section])
          );
          return groupedClasses;
        } else {
          return { error: response.problem };
        }
      }
    };

    this.getStudentBoardingType = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getStudentBoardingType(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results[0] && response.data.results;
        } else {
          return { error: response.problem };
        }
      }
    };

    this.getContentNode = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getContentNode(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.addContentNode = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.addContentNode(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.editContentNode = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.editContentNode(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.getContentAssociation = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getContentAssociation(config);
        if (response.ok && response.data && response.data.results) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.addContentAssociation = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.addContentAssociation(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.editContentAssociation = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.editContentAssociation(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.getS3Credentials = function* () {
      let response = yield Api.getS3Creds();

      if (response && response.ok && response.status === 200) {
        return response.data;
      } else {
        return false;
      }
    };

    this.getGlossary = function* (that) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getGlossary();
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
    };

    this.getOrganization = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getOrganization(config);
        const organization = JSON.parse(response.data.results[0].org);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0 &&
          organization &&
          organization.length
        ) {
          return organization[0];
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.getMetaData = function* (that, options) {
      const { metaType, config } = options;
      let response, headerconfig;

      let token = that.phiRef.getSession();
      if (token) {
        const metaDataMap = {
          city: (config) => Api.getCity(config || { stateId: 2 }),
          district: (config) => Api.getDistrict(config || {}),
          state: (config) =>
            Api.getStates(
              config || {
                countryId: CONSTANTS.defaultRegionCodes.INDIA_COUNTRY_CODE,
              }
            ),
          country: (config) => Api.getCountry(config || {}),
        };
        const response = yield metaDataMap[metaType](config);

        if (
          response &&
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          let metadata = response.data.results;
          return metadata.map((a) => a);
        } else {
          return { error: response.problem };
        }
      }
    };

    this.uploadToS3 = function* (file, s3CredsData, schoolContentID) {
      let form = new FormData();
      let key;
      const options = {
        enctype: "multipart/form-data",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      key =
        s3CredsData.conditions[7][2] +
        `${schoolContentID}/` +
        file.name.replace(/.*[\/\\]/, "");
      form.append("bucket", s3CredsData.conditions[0].bucket);
      form.append("key", key);
      form.append("acl", s3CredsData.conditions[1]["acl"]);
      form.append("Content-Type", file.type);
      form.append(
        "x-amz-meta-uuid",
        s3CredsData.conditions[5]["x-amz-meta-uuid"]
      );
      form.append(
        "x-amz-server-side-encryption",
        s3CredsData.conditions[6]["x-amz-server-side-encryption"]
      );
      form.append(
        "X-Amz-Credential",
        s3CredsData.conditions[2]["x-amz-credential"]
      );
      form.append(
        "X-Amz-Algorithm",
        s3CredsData.conditions[3]["x-amz-algorithm"]
      );
      form.append("X-Amz-Date", s3CredsData.conditions[4]["x-amz-date"]);
      form.append("x-amz-meta-tag", s3CredsData.conditions[9][2]);
      form.append("Policy", s3CredsData.policy);
      form.append("X-Amz-Signature", s3CredsData.signature);
      form.append("file", file);

      let response = yield Api.uploadToS3(form, options);
      return response;
    };

    this.getHealthOverviewReport = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getHealthOverviewReport(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.getClassOverviewReport = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getClassOverviewReport(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.getHygieneOverviewReport = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getHygieneOverviewReport(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.fetchDMFTIndex = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.fetchDMFTIndex({
          studentId: config.studentId,
          inEventTrackId: config.startNodeId,
        });

        if (!response.ok) {
          return { error: response.problem };
        } else if (response.data && response.data.status === 200) {
          return response.data.results;
        } else {
          return { error: "Invalid data returned" };
        }
      } else {
        return { error: "authentication error" };
      }
    };

    this.getGenderOverviewReport = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getGenderOverviewReport(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };

    this.getVaccination = function* (that) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getVaccination();

        if (!response.ok) {
          return { ok: false, error: response.problem };
        } else if (response.data && response.data.status === 200) {
          return { ok: true, data: response.data };
        } else {
          return { ok: false, error: "Failed to submit appointment request" };
        }
      } else {
        return { ok: false, error: "authentication error" };
      }
    };

    this.getGrowthOverviewReport = function* (that, config) {
      let token = that.phiRef.getSession();
      if (Boolean(token) && Boolean(token.jwt)) {
        let response = yield Api.getGrowthOverviewReport(config);
        if (
          response.ok &&
          response.data &&
          response.data.results &&
          response.data.results.length > 0
        ) {
          return response.data.results;
        } else {
          return { error: response.problem };
        }
      }
      return null;
    };
  }
}

//new generator fucntion for organization overview api //

// this.getOrganizationOverview = function* (that, param) {
//     let token = that.phiRef.getSession(); // Get the session token
//     if (Boolean(token) && Boolean(token.jwt)) { // Check if token exists
//         // Use the provided API function to make the request
//         let response = yield Api.getOrganizationOverview(param);
//         // Check if the response is successful and contains data
//         if (response.ok && response.data && response.data.results && response.data.results.length > 0 ) {
//             // Return the results if available
//             return response.data.results;
//         } else {
//             // Return an error if there's a problem with the response
//             return { error: response.problem };
//         }
//     }
//     // Return null if authentication error or session token is missing
//     return null;
// }
